var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReihenhausActive = function SvgReihenhausActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#656565",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.965 31.928V55.5h23.95V31.928H3.965zm9.554 9.603H7.408V35.42h6.111v6.111zm10.476 0h-6.111V35.42h6.111v6.111zM27.918 31.928V55.5h24V31.928h-24zm10.045 9.603h-6.111V35.42h6.111v6.111zm10.476 0h-6.111V35.42h6.111v6.111z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 27.817-6.894-9.858H10.877L.5 32.801M55.5 32.801 45.122 17.959H34.894L28 27.817"
  }))));
};
export default SvgReihenhausActive;